/**
 * Apply LTR/RTL direction per block for mixed English + Arabic rich text.
 * - Arabic-only blocks → dir="rtl"
 * - English-only blocks → dir="ltr"
 * - Mixed / unknown → dir="auto" (browser uses first strong character)
 * Respects Quill's ql-direction-rtl / ql-direction-ltr when present.
 */
export function applyBidiDirectionToHtml(html) {
  if (!html || typeof html !== "string") {
    return html || "";
  }

  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    return html;
  }

  var parser = new DOMParser();
  var doc = parser.parseFromString(
    '<div id="bidi-root">' + html + "</div>",
    "text/html"
  );
  var root = doc.getElementById("bidi-root");
  if (!root) {
    return html;
  }

  var arabicRe = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  var latinRe = /[A-Za-z]/;

  function resolveDir(el) {
    var className = el.className || "";
    if (typeof className !== "string") {
      className = "";
    }

    if (className.indexOf("ql-direction-rtl") !== -1) {
      return "rtl";
    }
    if (className.indexOf("ql-direction-ltr") !== -1) {
      return "ltr";
    }

    var existingDir = el.getAttribute("dir");
    if (existingDir === "rtl" || existingDir === "ltr" || existingDir === "auto") {
      return existingDir;
    }

    var text = el.textContent || "";
    var hasArabic = arabicRe.test(text);
    var hasLatin = latinRe.test(text);

    if (hasArabic && !hasLatin) {
      return "rtl";
    }
    if (hasLatin && !hasArabic) {
      return "ltr";
    }
    return "auto";
  }

  var blockSelector = "p, li, h1, h2, h3, h4, h5, h6, blockquote";
  var blocks = root.querySelectorAll(blockSelector);
  for (var i = 0; i < blocks.length; i++) {
    blocks[i].setAttribute("dir", resolveDir(blocks[i]));
  }

  var lists = root.querySelectorAll("ul, ol");
  for (var j = 0; j < lists.length; j++) {
    var list = lists[j];
    var items = list.children;
    var arabicCount = 0;
    var latinCount = 0;

    for (var k = 0; k < items.length; k++) {
      var item = items[k];
      if (!item || item.tagName !== "LI") {
        continue;
      }
      var itemText = item.textContent || "";
      if (arabicRe.test(itemText)) {
        arabicCount++;
      }
      if (latinRe.test(itemText)) {
        latinCount++;
      }
    }

    if (arabicCount > latinCount) {
      list.setAttribute("dir", "rtl");
    } else if (latinCount > arabicCount) {
      list.setAttribute("dir", "ltr");
    } else if (arabicCount > 0) {
      list.setAttribute("dir", "auto");
    }
  }

  return root.innerHTML;
}
